import React, { createContext, useState, useEffect } from 'react';

const PlaceContext = createContext();

const PlaceIdProvider = ({ children }) => {
  const [placeId, setPlaceId] = useState(null);
  useEffect(() => {
    const place_id = localStorage.getItem('place_id');
    if (place_id) {
      setPlaceId(place_id);
    }
  }, []);

  return <PlaceContext.Provider value={{ placeId, setPlaceId }}>{children}</PlaceContext.Provider>;
};

export { PlaceContext, PlaceIdProvider };
